module.exports = __webpack_public_path__ + "booking_ico.png?78a4569cc2a5d12390f3a88aaa777da8";